export const IMAGE_UPLOAD_ACCEPT = "image/jpeg,image/png,image/webp";
export const MAX_IMAGE_UPLOAD_BYTES = 10 * 1024 * 1024;
export const IMAGE_UPLOAD_HELP = "JPEG, PNG, or WebP — up to 10 MB each.";

const SUPPORTED_IMAGE_TYPES = new Set(["image/jpeg", "image/png", "image/webp"]);

export const getImageUploadError = (file) => {
  if (!file) return null;
  if (!SUPPORTED_IMAGE_TYPES.has(file.type)) {
    return "Choose a JPEG, PNG, or WebP image.";
  }
  if (file.size > MAX_IMAGE_UPLOAD_BYTES) {
    return "Each image must be 10 MB or smaller.";
  }
  return null;
};

export const getImageUploadsError = (files) => {
  for (const file of Array.from(files || [])) {
    const error = getImageUploadError(file);
    if (error) return error;
  }
  return null;
};
